import React from "react";
import { AiFillApi, AiOutlineCodepen } from "react-icons/ai";
import { GiValve } from "react-icons/gi";
import { WiRain } from "react-icons/wi";
import { RiGpsFill, RiTempColdLine } from "react-icons/ri";

const BASE_STYLE = {
  cursor: "pointer",
  stroke: "none",
};

export function Pin({ size = 30, color = "rgb(0,0,0)" }: { size?: number; color?: string }) {
  const ICON = `M20.2,15.7L20.2,15.7c1.1-1.6,1.8-3.6,1.8-5.7c0-5.6-4.5-10-10-10S2,4.5,2,10c0,2,0.6,3.9,1.6,5.4c0,0.1,0.1,0.2,0.2,0.3
  c0,0,0.1,0.1,0.1,0.2c0.2,0.3,0.4,0.6,0.7,0.9c2.6,3.1,7.4,7.6,7.4,7.6s4.8-4.5,7.4-7.5c0.2-0.3,0.5-0.6,0.7-0.9
  C20.1,15.8,20.2,15.8,20.2,15.7z`;
  const pinStyle = {
    cursor: "pointer",
    fill: "#d00",
    stroke: "none",
  };

  const strokeWidth = 2;
  const padding = strokeWidth;

  return (
    <svg
      height={size}
      width={size}
      viewBox={`${-padding} ${-padding} ${24 + padding * 2} ${24 + padding * 2}`}
      style={{ ...pinStyle }}
    >
      <path
        d={ICON}
        fill={color}
        stroke="#e5e5e5"
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}

export function PinGateway({
  size = 30,
  pinColor = "#007ACC",
  iconColor = "white",
}: {
  size?: number;
  pinColor?: string;
  iconColor?: string;
}) {
  const iconSize = size * 0.6;

  return (
    <div
      style={{
        position: "relative",
        width: size,
        height: size,
        lineHeight: 0,
        display: "inline-block",
      }}
    >
      <Pin size={size} color={pinColor} />

      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -60%)",
          fontSize: iconSize,
          color: iconColor,
          pointerEvents: "none",
        }}
      >
        <AiFillApi />
      </div>
    </div>
  );
}

export function PinValve({
  size = 30,
  pinColor = "#FF5722",
  iconColor = "white",
}: {
  size?: number;
  pinColor?: string;
  iconColor?: string;
}) {
  const iconSize = size * 0.6;

  return (
    <div
      style={{
        position: "relative",
        width: size,
        height: size,
        display: "inline-block",
        lineHeight: 0,
      }}
    >
      <Pin size={size} color={pinColor} />

      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -60%)",
          fontSize: iconSize,
          color: iconColor,
          pointerEvents: "none",
        }}
      >
        <GiValve />
      </div>
    </div>
  );
}

export function PinEnv({
  size = 30,
  pinColor = "#4CAF50",
  iconColor = "white",
}: {
  size?: number;
  pinColor?: string;
  iconColor?: string;
}) {
  const iconSize = size * 0.6;

  return (
    <div
      style={{
        position: "relative",
        width: size,
        height: size,
        display: "inline-block",
        lineHeight: 0,
      }}
    >
      <Pin size={size} color={pinColor} />

      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -60%)",
          fontSize: iconSize,
          color: iconColor,
          pointerEvents: "none",
        }}
      >
        <RiTempColdLine />
      </div>
    </div>
  );
}

export function PinTracker({
  size = 30,
  pinColor = "#00a5a8",
  iconColor = "white",
}: {
  size?: number;
  pinColor?: string;
  iconColor?: string;
}) {
  const iconSize = size * 0.58;

  return (
    <div
      style={{
        position: "relative",
        width: size,
        height: size,
        display: "inline-block",
        lineHeight: 0,
      }}
    >
      <Pin size={size} color={pinColor} />
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -60%)",
          fontSize: iconSize,
          color: iconColor,
          pointerEvents: "none",
        }}
      >
        <RiGpsFill />
      </div>
    </div>
  );
}

export function PinRain({
  size = 30,
  pinColor = "#2196F3",
  iconColor = "white",
}: {
  size?: number;
  pinColor?: string;
  iconColor?: string;
}) {
  const iconSize = size * 0.6;

  return (
    <div
      style={{
        position: "relative",
        width: size,
        height: size,
        display: "inline-block",
        lineHeight: 0,
      }}
    >
      <Pin size={size} color={pinColor} />

      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -60%)",
          fontSize: iconSize,
          color: iconColor,
          pointerEvents: "none",
        }}
      >
        <WiRain />
      </div>
    </div>
  );
}
